<template>
  <div
    v-if="virtual.isVirtual && virtual.visitorCanSwitch"
    class="text-center"
  >
    <v-radio-group
      :value="user.visit_type"
      @change="changeVisitType"
    >
      <template v-slot:label>
        <h6 class="text-h6">{{ $t('settings.visit_types.title') }}</h6>
      </template>

      <v-radio
        v-for="visit_type in visitTypes"
        :key="visit_type"
        :label="$t(`settings.visit_types.options.${visit_type}`)"
        :value="visit_type"
      ></v-radio>
    </v-radio-group>

    <v-divider />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

const visitTypes = [
  'live',
  'virtual'
]

export default {
  data() {
    return {
      visitTypes,
      savingSettings: false
    }
  },

  computed: {
    ...mapState('common', ['virtual']),
    ...mapState('auth', ['user']),
  },

  methods: {
    ...mapMutations('auth', ['changeVisitType']),
  }
}
</script>
